// extracted by mini-css-extract-plugin
export default {"root":"background_root__0Pz2L","spin":"background_spin__-ty6j"};